import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Store, select } from "@ngrx/store";
import { LunexService } from '../services/lunex.service';
import * as rootReducers from '@root/reducers';
import * as loginReducers from '@modules/login/reducers';
import * as merchantReducers from '@modules/profile/reducers';
import { GetMerchantDetail } from '@root/modules/profile/actions/merchant-detail.actions';
import { filter, switchMap } from 'rxjs/operators';


@Component({
  selector: 'edex-topup-vt',
  templateUrl: './topup-vt.component.html',
  styleUrls: ['./topup-vt.component.scss']
})
export class TopupVtComponent implements OnInit {
  topUpForm!:FormGroup
  submit:boolean=false
  providers:any[] =[];
  type: string;
  myNumber: number;
  public merchantDetail$ = this.store.pipe(select(merchantReducers.getMerchantDetailCollection));
  public user$ = this.store.pipe(select(loginReducers.getUser));
  userType: string;
  bankName: string;
  qrCode: string;
  bankAccountName: string;
  bankProcessingStatement: string;
  accounts$: any;
  stellar_history: any;
  contactName: any;
  merchantId: any;
  constructor(private _fb:FormBuilder,
    private store: Store<rootReducers.State>, private adminApis: LunexService,private _snackBar: MatSnackBar) { 
  }

  ngOnInit() {
    this.getProviders();
    this.setordersform() 
    this.user$.subscribe((user) => {
      this.contactName = user.contactName
      this.merchantId = user._id;
      this.topUpForm.patchValue({merchantid: this.merchantId, merchantname: this.contactName})
  });
  }
  getProviders() { 
    this.adminApis.getProviders(this.type='TOPUP').subscribe(
      res => {
        if(!res.error) {
          this.providers = res.body;
          if(!this.adminApis.allProviders.length) {
            this.adminApis.allProviders = this.providers;
          }
        }
      }, error => {

      }
    )
  }
  setordersform(){
    // <!-- amount, lang, merchantid, merchantname, phone, promo_phone, quantity, sku -->
    this.topUpForm=this._fb.group({
      amount:['',[Validators.required,Validators.min(1),Validators.max(200)]],
      phone:['2111111111',Validators.required],
      lang:['en'],
      merchantid:[this.merchantId ||''],
      merchantname:[this.contactName ||''],
      // phone_type:[''],
      // quantity:[''],
      product:['', Validators.required],
      sku:['',Validators.required],
    })
    this.topUpForm.get('product').valueChanges.subscribe(res => {
      this.topUpForm.patchValue({sku: res});
    })
  }

  submitTopUp(){
    this.submit = true
    if(this.topUpForm.invalid){
      if(this.topUpForm.value.amount >= 200 || this.topUpForm.value.amount == 0){
      this._snackBar.open('Amount should be between 1 to 200','',{ duration: 2000 });
      }
      return
    }
    let data={
      amount:parseInt(this.topUpForm.value.amount),
      phone:this.topUpForm.value.phone,
      lang:this.topUpForm.value.lang,
      merchantid:this.topUpForm.value.merchantid,
      merchantname:this.topUpForm.value.merchantname,
      phone_type:this.topUpForm.value.phone_type,
      // quantity:this.topUpForm.value.quantity,
      quantity:1,
      sku:this.topUpForm.value.sku,
    }    
    this.adminApis.phoneTopup(data).subscribe(res=>{
      let msg = (res && res.body && res.body.Message) ? res.body.Message  : '';
      if(res && res.body && res.body.Order){
        msg = 'Order Added Successfully'
        this.topUpForm.reset({
          product:this.topUpForm.controls.product.clearValidators(),
          amount:this.topUpForm.controls.amount.clearValidators(),
          phone:"2111111111",
          sku: this.topUpForm.controls.sku.clearValidators(),
          merchantid:this.merchantId,
          merchantname:this.contactName,
        });
      }
      this._snackBar.open(msg, '', { duration: 2000 });      
      this.submit = false;
    }, error => {
      this.submit = false;
      this._snackBar.open('Oops! something went wrong, please try again later.', '', { duration: 2000 });
    })
  }


}
